import axios from 'axios';
import AuthService from './AuthService';

class InvoicesService{

    authService = null;

    constructor(){
        this.authService = new AuthService();
    }

    async getInvoices(){
        let config = this.authService.getConfig();
        let r = await axios.post('http://192.168.34.46/nordia_new/api/login', {
                "SubscriptionPassword": "nordia",
                "SubscriptionID": config.whCode !== '4'  ? 'nordia_new_003' : "nordia_new",
                "model": {
                "BranchID": config.whCode !== '4' ? 1 : 2,
                "CompanyID": config.whCode !== '4' ? '003' : '001',
                "DatabaseID": "Nordia",
                "UserID": config.whCode !== '4' ? 'webapi003' : "webapi",
                "Password": "webapi1234",
                "LangID": "el-GR"
            }
        });
        let token = r.data.Model.WebApiToken;
        let invoicesPromise = new Promise((resolve, reject) => {
            if(config.whCode === '4'){
            
                axios.get('http://192.168.34.46/nordia_new/api/rpc/SimpleScrollerRootTable/WEB_Scrolls/API_VolakasOrdersData', {
                    headers: { authorization: 'Bearer ' + token }
                }).then(r => {
                    resolve(r.data)
                }).catch(e => reject(e.message));
            }
            else{
                axios.get('http://192.168.34.46/nordia_new/api/rpc/SimpleScrollerRootTable/WEB_Scrolls/API_NordiaEnergyOrdersData', {
                    headers: { authorization: 'Bearer ' + token }
                }).then(r => {
                    resolve(r.data);
                }).catch(e => reject(e.message));
            }
        });
        return invoicesPromise;
    }

    async assignVehicles(selectedVehicle, selectedInvoice, invoices){
        let conf = this.authService.getConfig();
        let config = conf;
        let r = await axios.post('http://192.168.34.46/nordia_new/api/login', {
                "SubscriptionPassword": "nordia",
                "SubscriptionID": config.whCode !== '4'  ? 'nordia_new_003' : "nordia_new",
                "model": {
                "BranchID": config.whCode !== '4' ? 1 : 2,
                "CompanyID": config.whCode !== '4' ? '003' : '001',
                "DatabaseID": "Nordia",
                "UserID": config.whCode !== '4' ? 'webapi003' : "webapi",
                "Password": "webapi1234",
                "LangID": "el-GR"
            }
        });
        let token = r.data.Model.WebApiToken;
        let assignVehiclePromise = new Promise((resolve, reject) => {
            if(conf.WHCode === '4'){
                axios.post('http://192.168.34.46/nordia_new/api/rpc/ScrollerCommand', {
                    "CommandID": "UpdateDocTruckPlates",
                    "ScrollerID": "WEB_Scrolls/API_VolakasOrdersData",
                    "ScrollerDataset": {"ESFILineItem": [{
                        "DocGID": invoices.filter(i => i.ADCode === selectedInvoice)[0].DocGID,
                        "Pinakida": selectedVehicle
                    }]}
                }, { headers: { authorization: 'Bearer ' + token }}).then(r => {
                    resolve(true);
                });
            }
            else{
                axios.post('http://192.168.34.46/nordia_new/api/rpc/ScrollerCommand', {
                    "CommandID": "UpdateDocTruckPlatesNE",
                    "ScrollerID": "WEB_Scrolls/API_NordiaEnergyOrdersData",
                    "ScrollerDataset": {"ESFILineItem": [{
                        "DocGID": invoices.filter(i => i.ADCode === selectedInvoice)[0].DocGID,
                        "Pinakida": selectedVehicle
                    }]}
                }, { headers: { authorization: 'Bearer ' + token }}).then(r => {
                    resolve(true);
                });
            }
        });
        return assignVehiclePromise;
        
    }
}

export default InvoicesService;